import { render, staticRenderFns } from "./CouponCollection.vue?vue&type=template&id=482dfbcb&scoped=true"
import script from "./CouponCollection.vue?vue&type=script&lang=js"
export * from "./CouponCollection.vue?vue&type=script&lang=js"
import style0 from "./CouponCollection.vue?vue&type=style&index=0&id=482dfbcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482dfbcb",
  null
  
)

export default component.exports